"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _BaggageAllowance = _interopRequireDefault(require("@airasia/phoenix-components/components/BaggageAllowance"));

var _Container = _interopRequireDefault(require("@airasia/phoenix-components/components/Container"));

var _JourneySegment = _interopRequireWildcard(require("@airasia/phoenix-components/components/JourneySegment"));

var _JourneyDetails = _interopRequireDefault(require("../JourneyDetails"));

var _constant = require("@airasia/phoenix-components/components/JourneySegment/constant");

var _JourneyPriceCTA = _interopRequireDefault(require("@airasia/phoenix-components/components/JourneyPriceCTA"));

var _BottomSheet = _interopRequireDefault(require("@airasia/phoenix-components/components/BottomSheet"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _NotificationBannerInline = _interopRequireDefault(require("@airasia/phoenix-components/components/NotificationBannerInline"));

var _constant2 = require("@airasia/phoenix-components/components/JourneyPriceCTA/constant");

var _constant3 = require("@airasia/phoenix-components/components/Popover/constant");

var _constant4 = require("./constant");

var _Journey = _interopRequireDefault(require("./Journey.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledJourneyContainer = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyContainer",
  componentId: "sc-1jgrxhn-0"
})(["", " display:flex;align-items:center;justify-content:space-between;cursor:pointer;"], function (_ref) {
  var hasPadding = _ref.hasPadding,
      isMobile = _ref.isMobile,
      theme = _ref.theme;
  return hasPadding && "\n      padding: ".concat(isMobile ? "".concat(theme.space.small, " ").concat(theme.space.small, "  ").concat(theme.space.none) : "".concat(theme.space.small, " 2.6%"), ";\n  ");
});

var StyledJourneyBody = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyBody",
  componentId: "sc-1jgrxhn-1"
})(function (_ref2) {
  var marginTop = _ref2.marginTop,
      isMobile = _ref2.isMobile;
  return "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 2;\n  width: ".concat(isMobile ? '100%' : '77.26%', ";\n  margin-right: 4.64%;\n  margin-top: ").concat(marginTop && "3.6%", ";\n\n");
});

var StyledJourneyBodyItem = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyBodyItem",
  componentId: "sc-1jgrxhn-2"
})(["display:flex;align-items:flex-end;justify-content:space-between;width:100%;", ""], function (_ref3) {
  var showBorder = _ref3.showBorder,
      theme = _ref3.theme;
  return showBorder && "\n      border-top: 1px solid ".concat(theme.colors.greyLight, ";\n      padding-top: ").concat(theme.space.XSmall, ";\n    ");
});

var StyledJourneyCTA = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyCTA",
  componentId: "sc-1jgrxhn-3"
})(["display:flex;align-items:end;width:18.1%;justify-content:flex-end;align-self:center;"]);

var StyledJourneyDetailsGrid = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyDetailsGrid",
  componentId: "sc-1jgrxhn-4"
})(["display:grid;padding-top:", ";padding-left:10%;width:65%;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.tiny;
});
/* istanbul ignore next */


var StyledJourneyFooter = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourneyFooter",
  componentId: "sc-1jgrxhn-5"
})(["padding:", ";background-color:", ";border-radius:", ";"], function (_ref5) {
  var theme = _ref5.theme,
      inlineDetails = _ref5.inlineDetails;
  return inlineDetails ? "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.small) : theme.space.small;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyLighter;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius.normal;
});

var StyledMobileHeaderMenu = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledMobileHeaderMenu",
  componentId: "sc-1jgrxhn-6"
})(["padding:", ";background:", ";box-shadow:", ";display:flex;align-items:center;justify-content:space-between;p{margin:0;}"], function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.normal, " ").concat(theme.space.XXXSmall);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.backgroundColor.default;
}, function (_ref10) {
  var theme = _ref10.theme;
  return "0px 2px 6px  ".concat(theme.colors.greyLight);
});

var StyledMobileJourneyDetail = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledMobileJourneyDetail",
  componentId: "sc-1jgrxhn-7"
})(["margin-bottom:20%;"]);

var StyledFooterCTA = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledFooterCTA",
  componentId: "sc-1jgrxhn-8"
})(["display:grid;padding:", ";box-shadow:", ";width:calc(100vw - 45px);background:", ";border-radius:0px;position:fixed;bottom:0;"], function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.space.XXXSmall, " ").concat(theme.space.semi);
}, function (_ref12) {
  var theme = _ref12.theme;
  return "0px 0px 6px  ".concat(theme.colors.greyLight);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.backgroundColor.primary;
});

var StyledNotificationBanner = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledNotificationBanner",
  componentId: "sc-1jgrxhn-9"
})(["padding:", ";div:first-child{padding:", ";p{font-weight:", ";font-size:", ";line-height:", ";}}"], function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.space.none, " 2.6%");
}, function (_ref15) {
  var theme = _ref15.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.micro);
}, function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.fontWeight.bold);
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.fontSize.XSmall);
}, function (_ref18) {
  var theme = _ref18.theme;
  return "".concat(theme.lineHeight.large);
});

var StyledNotificationBannerContainer = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledNotificationBannerContainer",
  componentId: "sc-1jgrxhn-10"
})(["display:flex;width:100%;", ""], function (_ref19) {
  var displayLastOnRight = _ref19.displayLastOnRight;
  return displayLastOnRight ? "\n    div:last-child {\n      margin-left: auto;\n    }" : "";
});

var StyledDivider = _styledComponents.default.hr.withConfig({
  displayName: "Journey__StyledDivider",
  componentId: "sc-1jgrxhn-11"
})(["border:none;border-bottom:", ";width:90%;margin:0;margin-block-start:0;margin-block-end:0;"], function (_ref20) {
  var theme = _ref20.theme;
  return "1px solid ".concat(theme.colors.greyLight);
});

var CustomText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Journey__CustomText",
  componentId: "sc-1jgrxhn-12"
})(["margin-right:", ";"], function (_ref21) {
  var theme = _ref21.theme,
      hasIcon = _ref21.hasIcon;
  return hasIcon ? theme.space.micro : theme.space.none;
});
var CustomAirAsiaPlus = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Journey__CustomAirAsiaPlus",
  componentId: "sc-1jgrxhn-13"
})(["margin-right:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.xxtiny;
});

var TagTitle = _styledComponents.default.div.withConfig({
  displayName: "Journey__TagTitle",
  componentId: "sc-1jgrxhn-14"
})(["background-color:", ";padding:", ";display:flex;align-items:center;margin-bottom:", ";border-radius:", ";"], function (_ref23) {
  var theme = _ref23.theme,
      bgColor = _ref23.bgColor;
  return theme.colors[bgColor];
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.space.nano, " ").concat(theme.space.micro);
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.XXXSmall;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.borderRadius.small;
});

var AirAsiaPlusContainer = _styledComponents.default.div.withConfig({
  displayName: "Journey__AirAsiaPlusContainer",
  componentId: "sc-1jgrxhn-15"
})(["padding-left:", ";"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.micro;
});

var TagContainer = _styledComponents.default.div.withConfig({
  displayName: "Journey__TagContainer",
  componentId: "sc-1jgrxhn-16"
})(["display:flex;flex-direction:row;"]);

var StyledJourney = _styledComponents.default.div.withConfig({
  displayName: "Journey__StyledJourney",
  componentId: "sc-1jgrxhn-17"
})([""]);

var Journey = function Journey(_ref28) {
  var accessible = _ref28.accessible,
      theme = _ref28.theme,
      customProperties = _ref28.customProperties,
      journeys = _ref28.journeys,
      tripType = _ref28.tripType,
      _handleClick = _ref28.handleClick,
      handleViewClick = _ref28.handleViewClick,
      carrierSize = _ref28.carrierSize,
      stopoverSize = _ref28.stopoverSize,
      translation = _ref28.translation,
      customGuestText = _ref28.customGuestText,
      customDetailText = _ref28.customDetailText,
      price = _ref28.price,
      isViDisclaimerDepart = _ref28.isViDisclaimerDepart,
      isViDisclaimerReturn = _ref28.isViDisclaimerReturn,
      guest = _ref28.guest,
      loading = _ref28.loading,
      disabled = _ref28.disabled,
      defaultDisabledFeatures = _ref28.defaultDisabledFeatures,
      locale = _ref28.locale,
      virtualInterlining = _ref28.virtualInterlining,
      showBaggageAllowance = _ref28.showBaggageAllowance,
      baggageDataList = _ref28.baggageDataList,
      hasNoCheckedBaggage = _ref28.hasNoCheckedBaggage,
      hasNoCheckedBaggageOnly = _ref28.hasNoCheckedBaggageOnly,
      journeyDetailsJourneys = _ref28.journeyDetailsJourneys,
      journeyDetailsTranslation = _ref28.journeyDetailsTranslation,
      isSelected = _ref28.isSelected,
      hasBoxShadow = _ref28.hasBoxShadow,
      hasPadding = _ref28.hasPadding,
      ctaPosition = _ref28.ctaPosition,
      ctaTextActionColor = _ref28.ctaTextActionColor,
      _ref28$ctaHorizontal = _ref28.ctaHorizontal,
      ctaHorizontal = _ref28$ctaHorizontal === void 0 ? tripType === _constant.TRIP_TYPES.oneway : _ref28$ctaHorizontal,
      ctaViewIconFirst = _ref28.ctaViewIconFirst,
      ctaViewIcon = _ref28.ctaViewIcon,
      ctaShowButton = _ref28.ctaShowButton,
      ctaInlineDetails = _ref28.ctaInlineDetails,
      showFlightDetails = _ref28.showFlightDetails,
      customEvent = _ref28.customEvent,
      _ref28$isBestDeal = _ref28.isBestDeal,
      isBestDeal = _ref28$isBestDeal === void 0 ? true : _ref28$isBestDeal,
      bundleType = _ref28.bundleType,
      showBundleType = _ref28.showBundleType,
      tagsList = _ref28.tagsList,
      isMobile = _ref28.isMobile,
      _ref28$isMobileStyleI = _ref28.isMobileStyleInDesktop,
      isMobileStyleInDesktop = _ref28$isMobileStyleI === void 0 ? false : _ref28$isMobileStyleI,
      strikethroughPrice = _ref28.strikethroughPrice,
      percentageDiscount = _ref28.percentageDiscount,
      customPercentageDiscountText = _ref28.customPercentageDiscountText,
      hourCycle = _ref28.hourCycle,
      useLocalTimezone = _ref28.useLocalTimezone,
      promoTags = _ref28.promoTags,
      showStackedImages = _ref28.showStackedImages,
      showCurrency = _ref28.showCurrency,
      defaultIDRLocale = _ref28.defaultIDRLocale,
      isAirasiaPlus = _ref28.isAirasiaPlus,
      onPressAirasiaPlus = _ref28.onPressAirasiaPlus,
      _ref28$airAsiaPlusTit = _ref28.airAsiaPlusTitle,
      airAsiaPlusTitle = _ref28$airAsiaPlusTit === void 0 ? '' : _ref28$airAsiaPlusTit;

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      showJourneyDetails = _React$useState4[0],
      setShowJourneyDetails = _React$useState4[1];
  /* istanbul ignore next */


  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var handleDetailViewClick = function handleDetailViewClick(event) {
    event.stopPropagation();

    if (showFlightDetails) {
      setShowJourneyDetails(!showJourneyDetails);
      handleViewClick(event);
    } else {
      customEvent();
    }
  };

  var language = _objectSpread(_objectSpread({}, _constant4.TRANSLATION), translation);

  var move = theme === _constant2.THEMES.MOVE;

  var getPopOverLabel = function getPopOverLabel(tag) {
    if (tag.title === _constant4.TAGS.VTL.title) {
      return /*#__PURE__*/_react.default.createElement(TagTitle, {
        bgColor: move ? 'purpleLight' : _constant4.TAGS.VTL.color
      }, /*#__PURE__*/_react.default.createElement(CustomText, {
        bold: true,
        type: _constant4.TEXT_TYPE.tag.type,
        color: move ? 'secondaryDark' : _constant4.TEXT_TYPE.tag.color
      }, language.vtlTitle || _constant4.TAGS.VTL.title), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        color: "secondaryBlue",
        fontsize: "titleSmall",
        icon: "InfoIcon"
      }));
    }

    if (tag && tag.title !== '') {
      return /*#__PURE__*/_react.default.createElement(TagTitle, {
        bgColor: move ? 'purpleLight' : _constant4.TAGS.VTL.color
      }, /*#__PURE__*/_react.default.createElement(CustomText, {
        bold: true,
        type: _constant4.TEXT_TYPE.tag.type,
        color: move ? 'secondaryDark' : _constant4.TEXT_TYPE.tag.color,
        hasIcon: !!tag.hasIcon
      }, tag.title), tag.hasIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        color: tag.iconColor ? tag.iconColor : _constant4.TEXT_TYPE.tag.iconColor,
        fontsize: _constant4.TEXT_TYPE.tag.fontSize,
        icon: tag.icon ? tag.icon : _constant4.TEXT_TYPE.tag.iconType
      }));
    }

    return null;
  };

  var getAirAsiaPlusTag = function getAirAsiaPlusTag(onClick) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      _react.default.createElement(AirAsiaPlusContainer, {
        onClick: onClick
      }, /*#__PURE__*/_react.default.createElement(TagTitle, {
        bgColor: move ? 'purpleLight' : _constant4.TAGS.VTL.color
      }, /*#__PURE__*/_react.default.createElement(CustomAirAsiaPlus, {
        bold: true,
        type: _constant4.TEXT_TYPE.tag.type,
        color: move ? 'secondaryDark' : _constant4.TEXT_TYPE.tag.color
      }, airAsiaPlusTitle || _constant4.TAGS.airasiaPlus), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        color: "secondaryBlue",
        fontsize: "titleSmall",
        icon: "InfoIcon"
      })))
    );
  };

  var getPopOverContent = function getPopOverContent(tag) {
    if (tag.title === _constant4.TAGS.VTL.title) {
      var subLabel = language.vtlLabel || _constant4.TAGS.VTL.label;
      var first = subLabel.slice(0, subLabel.indexOf('{'));
      var link = subLabel.slice(subLabel.indexOf('{') + 1, subLabel.indexOf('}'));
      var third = subLabel.slice(subLabel.indexOf('}') + 1);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, first && /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: _constant4.TEXT_TYPE.label.type,
        color: _constant4.TEXT_TYPE.label.color,
        display: "",
        tag: "span"
      }, first), link && /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: tag.redirectLink,
        target: "tab",
        color: "secondaryBlue",
        hoverUnderlined: true,
        size: "small"
      }, link), third && /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: _constant4.TEXT_TYPE.label.type,
        color: _constant4.TEXT_TYPE.label.color,
        display: "",
        tag: "span"
      }, third));
    }

    return null;
  };

  var getPopOverTag = function getPopOverTag(tag) {
    return /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessibile: true,
      asToolTip: true,
      content: getPopOverContent(tag),
      position: isMobile || isMobileStyleInDesktop ? _constant3.CONTENT_POSITION.BOTTOM : _constant3.CONTENT_POSITION.RIGHT,
      trigger: _constant3.TRIGGERS.click,
      width: isMobile || isMobileStyleInDesktop ? 200 : 300,
      zIndex: 2
    }, getPopOverLabel(tag));
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    accessible: false,
    focusEffect: false,
    hoverEffect: false,
    theme: theme,
    hasBoxShadow: hasBoxShadow,
    height: true,
    hasBorder: isSelected,
    borderColor: isSelected ? 'tertiary' : null
  }, /*#__PURE__*/_react.default.createElement(StyledNotificationBannerContainer, {
    displayLastOnRight: bundleType && bundleType.length > 0 && showBundleType
  }, isBestDeal && /*#__PURE__*/_react.default.createElement(StyledNotificationBanner, null, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
    accessible: true,
    border: false,
    closable: false,
    device: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth) ? 'mobile' : 'desktop',
    fullWidth: false,
    isBannerClickable: true,
    message: language.bestDeal,
    showLeftIcon: false,
    smallerPadding: true,
    textType: "small",
    theme: theme,
    type: "error"
  })), bundleType && bundleType.length > 0 && showBundleType && /*#__PURE__*/_react.default.createElement(StyledNotificationBanner, null, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
    accessible: true,
    border: false,
    closable: false,
    device: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth) ? 'mobile' : 'desktop',
    fullWidth: false,
    isBannerClickable: true,
    message: bundleType,
    showLeftIcon: false,
    smallerPadding: true,
    textType: "small",
    theme: theme,
    type: "error"
  }))), /*#__PURE__*/_react.default.createElement(StyledJourneyContainer, {
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth),
    tabIndex: !accessible ? '-1' : '0',
    customProperties: customProperties,
    isOneway: tripType === _constant.TRIP_TYPES.oneway,
    hasPadding: hasPadding,
    inlineDetails: ctaInlineDetails
  }, /*#__PURE__*/_react.default.createElement(StyledJourneyBody, {
    marginTop: tripType === 'O',
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth)
  }, /*#__PURE__*/_react.default.createElement(TagContainer, null, tagsList.length > 0 && tagsList.map(function (tag) {
    return getPopOverTag(tag);
  }), isAirasiaPlus && getAirAsiaPlusTag(onPressAirasiaPlus)), /*#__PURE__*/_react.default.createElement(StyledJourney, {
    onClick: handleDetailViewClick
  }, journeys.map(function (journey, index) {
    return /*#__PURE__*/_react.default.createElement(StyledJourneyBodyItem, {
      showBorder: index === 1,
      key: Math.random()
    }, /*#__PURE__*/_react.default.createElement(_JourneySegment.default, {
      hourCycle: hourCycle,
      locale: locale,
      accessible: accessible,
      theme: theme,
      carriers: journey.carriers,
      designator: journey.designator,
      tripType: tripType,
      segments: journey.segments,
      showStopoverText: true,
      depart: index === 0,
      carrierSize: carrierSize,
      stopoverSize: stopoverSize,
      translation: translation,
      handleViewClick: handleDetailViewClick,
      isViDisclaimer: index === 0 && index !== undefined ? isViDisclaimerDepart : isViDisclaimerReturn,
      carrierLogoCustomProperties: {
        placeHolderBackground: 'default'
      },
      customProperties: {
        className: "js",
        id: "js-".concat(index)
      },
      isMobile: isMobile,
      isMobileStyleInDesktop: isMobileStyleInDesktop,
      isSubjectToGovtApproval: journey.subjectToGovtApproval,
      useLocalTimezone: useLocalTimezone,
      showStackedImages: showStackedImages
    }));
  }), showBaggageAllowance && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(_BaggageAllowance.default, {
    accessible: false,
    theme: theme,
    hasBorder: false,
    hasBoxShadow: false,
    hasHeader: false,
    dataList: baggageDataList,
    imgHeight: 16,
    imgWidth: 16,
    translation: translation
  })))), !(isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth)) && /*#__PURE__*/_react.default.createElement(StyledJourneyCTA, {
    isOneway: tripType === _constant.TRIP_TYPES.oneway
  }, /*#__PURE__*/_react.default.createElement(_JourneyPriceCTA.default, {
    accessible: accessible,
    theme: theme,
    price: price,
    strikethroughPrice: strikethroughPrice,
    percentageDiscount: percentageDiscount,
    customPercentageDiscountText: customPercentageDiscountText,
    guest: guest,
    tripType: tripType,
    handleClick: function handleClick(event) {
      return _handleClick(event);
    },
    handleViewClick: function handleViewClick(event) {
      return handleDetailViewClick(event);
    },
    translation: translation,
    customGuestText: customGuestText,
    customDetailText: customDetailText,
    customIconSize: "medium",
    loading: loading,
    disabled: disabled,
    defaultDisabledFeatures: defaultDisabledFeatures,
    locale: locale,
    customProperties: {
      id: "jcta-desktop"
    },
    isSelected: isSelected,
    horizontal: ctaHorizontal,
    ctaPosition: ctaPosition,
    viewIconColor: ctaTextActionColor,
    viewIconFirst: ctaViewIconFirst,
    viewIcon: ctaViewIcon,
    showButton: ctaShowButton,
    inlineDetails: ctaInlineDetails,
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth),
    promoTags: promoTags,
    showCurrency: showCurrency,
    defaultIDRLocale: defaultIDRLocale
  }))), showJourneyDetails && (!(isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth)) ? /*#__PURE__*/_react.default.createElement(StyledJourneyDetailsGrid, null, /*#__PURE__*/_react.default.createElement(_JourneyDetails.default, {
    accessible: true,
    customProperties: {
      'aria-label': 'this is an a11y custom label',
      id: 'customPropsID'
    },
    journeys: journeyDetailsJourneys,
    theme: theme,
    translation: journeyDetailsTranslation,
    tripType: tripType,
    showBaggageAllowance: showBaggageAllowance,
    hasNoCheckedBaggage: hasNoCheckedBaggage,
    hasNoCheckedBaggageOnly: hasNoCheckedBaggageOnly,
    baggageDataList: baggageDataList,
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth),
    hourCycle: hourCycle,
    virtualInterlining: virtualInterlining
  })) : /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
    background: "default",
    height: "100%",
    isAnimationOn: true,
    show: true,
    theme: theme,
    zIndex: _constant4.Z_INDEX.FLIGHT_DETAILS
  }, /*#__PURE__*/_react.default.createElement(StyledMobileHeaderMenu, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: true,
    display: "flex",
    theme: theme,
    type: "default",
    marginBottom: "normal",
    customProperties: {
      style: {
        marginLeft: 10,
        fontWeight: 500
      }
    }
  }, journeyDetailsTranslation.flightDetailsHeader), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: true,
    color: "neutral",
    fontsize: "normal",
    icon: "CloseIcon",
    theme: theme,
    customProperties: {
      onClick: function onClick(event) {
        return handleDetailViewClick(event);
      },
      style: {
        paddingRight: 13
      }
    }
  })), /*#__PURE__*/_react.default.createElement(StyledMobileJourneyDetail, null, /*#__PURE__*/_react.default.createElement(_JourneyDetails.default, {
    accessible: true,
    customProperties: {
      style: {
        padding: 16
      }
    },
    journeys: journeyDetailsJourneys,
    theme: theme,
    translation: journeyDetailsTranslation,
    tripType: tripType,
    showBaggageAllowance: showBaggageAllowance,
    hasNoCheckedBaggage: hasNoCheckedBaggage,
    hasNoCheckedBaggageOnly: hasNoCheckedBaggageOnly,
    baggageDataList: baggageDataList,
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth),
    hourCycle: hourCycle,
    virtualInterlining: virtualInterlining
  })), /*#__PURE__*/_react.default.createElement(StyledFooterCTA, null, /*#__PURE__*/_react.default.createElement(_JourneyPriceCTA.default, {
    strikethroughPrice: strikethroughPrice,
    percentageDiscount: percentageDiscount,
    customPercentageDiscountText: customPercentageDiscountText,
    accessible: true,
    customDetailText: null,
    customProperties: promoTags && promoTags.length > 0 && {
      style: {
        height: 'auto'
      }
    },
    guest: guest,
    handleClick: function handleClick(event) {
      return _handleClick(event);
    },
    handleViewClick: function handleViewClick() {},
    horizontal: true,
    price: price,
    locale: locale,
    theme: theme,
    translation: translation,
    promoTags: promoTags,
    showCurrency: showCurrency,
    defaultIDRLocale: defaultIDRLocale
  })))), (isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth)) &&
  /*#__PURE__*/

  /* istanbul ignore next */
  _react.default.createElement(StyledJourneyFooter, {
    onClick: handleDetailViewClick,
    inlineDetails: ctaInlineDetails
  }, /*#__PURE__*/_react.default.createElement(_JourneyPriceCTA.default, {
    strikethroughPrice: strikethroughPrice,
    percentageDiscount: percentageDiscount,
    customPercentageDiscountText: customPercentageDiscountText,
    accessible: accessible,
    theme: theme,
    price: price,
    guest: guest,
    handleClick: function handleClick(event) {
      return _handleClick(event);
    },
    handleViewClick: function handleViewClick(event) {
      return handleDetailViewClick(event);
    },
    translation: translation,
    customGuestText: customGuestText,
    customDetailText: customDetailText,
    loading: loading,
    disabled: disabled,
    defaultDisabledFeatures: defaultDisabledFeatures,
    locale: locale,
    customProperties: _objectSpread({
      id: 'jcta-mobile'
    }, customProperties),
    isSelected: isSelected,
    horizontal: ctaHorizontal,
    ctaPosition: ctaPosition,
    viewIconColor: ctaTextActionColor,
    viewIconFirst: ctaViewIconFirst,
    viewIcon: ctaViewIcon,
    showButton: ctaShowButton,
    isMobile: isMobileStyleInDesktop || (0, _JourneySegment.setBreakpoint)(windowWidth),
    inlineDetails: ctaInlineDetails,
    promoTags: promoTags,
    showCurrency: showCurrency,
    defaultIDRLocale: defaultIDRLocale
  }))));
};

Journey.propTypes = _Journey.default.PropTypes;
Journey.defaultProps = _Journey.default.DefaultProps;
var _default = Journey;
exports.default = _default;